export const allowedPageSizes = [10, 25, 50, 100];

export const defaultPageSize = allowedPageSizes[0];
